// components/EventContent/EventDetailContent.js

import React from 'react';
import styled from 'styled-components';
import Typography from '../Typography';
import Tag from '../Tag';
import { getVehicleTypeLabel } from '../../constants/vehicleTypes';
import OrganizerBlock from './OrganizerBlock';
import PropTypes from 'prop-types';
import InfoCircleOutlineIcon from '../Icons/InfoCircleOutlineIcon';
import { theme } from '../../theme';
import InfoCircleIcon from '../Icons/InfoCircleIcon';
import { useTranslation } from 'react-i18next';
// import i18n from '../../i18n';
import { ALL_VEHICLE_TYPES } from '../../constants/vehicleTypes';

const EventDetailContent = ({ image, description, organizer, eventId, allowedVehicleTypes = [], needsVehicle = true }) => {
  const { t: tEventDetail } = useTranslation('eventDetail');
  return (
    <EventContentContainer>
      <EventImage src={image} alt="Imagen del evento" />
      <EventDescription>
        <Typography $variant="title-5-semibold" $variantTablet="body-1-semibold" $variantMobile="body-1-semibold" as='p'>{tEventDetail('eventDescription.title')}</Typography>
        <Typography $variant="body-1-regular">{description}</Typography>
      </EventDescription>

      {needsVehicle && (
        <EventAllowedVehicles>
          {(
            !allowedVehicleTypes || allowedVehicleTypes.length === 0 || allowedVehicleTypes.length === ALL_VEHICLE_TYPES.length
          ) ? (
            <AllowedVehiclesHeader>
              <AllowedVehiclesTitle>
                <InfoCircleIcon fill={theme.colors.defaultStrong} width={16} height={16} />
                <Typography color={theme.colors.defaultStrong} $variant="body-1-semibold" $variantTablet="body-1-semibold" $variantMobile="body-1-semibold" as='p'>{tEventDetail('allowedVehicles.title', 'Este evento requiere un vehiculo')}</Typography>
              </AllowedVehiclesTitle>
              <Typography color={theme.colors.defaultWeak} $variant="body-2-medium">
                {tEventDetail('allowedVehicles.baseDescription', 'Para inscribirte necesitas indicar el vehiculo con el que asistirás.')}
              </Typography>
            </AllowedVehiclesHeader>
          ) : (
            <>
              <AllowedVehiclesHeader>
                <AllowedVehiclesTitle>
                  <InfoCircleIcon fill={theme.colors.defaultStrong} width={16} height={16} />
                  <Typography color={theme.colors.defaultStrong} $variant="body-1-semibold" $variantTablet="body-1-semibold" $variantMobile="body-1-semibold" as='p'>{tEventDetail('allowedVehicles.title', 'Este evento requiere un vehiculo')}</Typography>
                </AllowedVehiclesTitle>
                <Typography color={theme.colors.defaultWeak} $variant="body-2-medium">
                  {tEventDetail('allowedVehicles.restrictedDescription', 'Para inscribirte necesitas indicar el vehiculo con el que asistirás. Los tipos vehiculos permitidos son:')}
                </Typography>
              </AllowedVehiclesHeader>
              <TagsList>
                {(allowedVehicleTypes || []).map((type, idx) => (
                  <Tag key={`${type}-${idx}`} $variant="subtle" $letterSpacing='0' $textTransform="none" $textStyle="body-3-semibold" $borderRadius="12px">
                    {getVehicleTypeLabel(type)}
                  </Tag>
                ))}
              </TagsList>
            </>
          )}
        </EventAllowedVehicles>
      )}

      <OrganizerBlock organizer={organizer} eventId={eventId} />
    </EventContentContainer>
  );
};

EventDetailContent.propTypes = {
  image: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  organizer: PropTypes.object.isRequired,
  eventId: PropTypes.string.isRequired,
};

export default EventDetailContent;

// Styled Components
const EventContentContainer = styled.div`
  grid-area: 1 / 1 / 2 / 8;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xl};
`;

const EventImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.radius.sm};
  aspect-ratio: 4/3;
  border: 1px solid ${({ theme }) => theme.border.defaultSubtle};
`;

// const PlaceholderImage = styled.div`
//   width: 100%;
//   height: 300px; /* Ajusta según tus necesidades */
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background-color: ${({ theme }) => theme.fill.defaultSubtle};
//   border-radius: ${({ theme }) => theme.radius.sm};

//   img {
//     width: 100px;
//     height: 100px;
//   }
// `;

const EventDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
  // padding: 0px 16px;
`;

const AllowedVehiclesHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
`;

const AllowedVehiclesTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.xs};
`;

const TagsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.sizing.xxs};
`;

const EventAllowedVehicles = styled.div`
  background-color: ${({ theme }) => theme.fill.defaultMain};
  border: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  border-radius: ${({ theme }) => theme.sizing.sm};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.sm};
  padding: ${({ theme }) => theme.sizing.sm};
`;
